module.exports = __webpack_public_path__ + "static/img/winner_top.0b0bab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winner_top.png
// module id = RWa3
// module chunks = 1